import { getReticulumFetchUrl } from "./phoenix-utils";

export const getNextHub = async event => {
  return await (await fetch(getReticulumFetchUrl("/api/v1/hubs-info?event=" + event))).text();
};
